/**
 * Adapter to make AuthService use UnifiedStorage
 * This overrides localStorage methods for auth_tokens key
 */

import { unifiedStorage } from './unified-storage';

// Store original localStorage methods
const originalSetItem = localStorage.setItem.bind(localStorage);
const originalGetItem = localStorage.getItem.bind(localStorage);
const originalRemoveItem = localStorage.removeItem.bind(localStorage);

// Override localStorage methods to intercept auth_tokens operations
export function initAuthStorageAdapter() {
  console.log('[AuthStorageAdapter] Initializing localStorage interceptors');

  // Override setItem
  Storage.prototype.setItem = function(key: string, value: string) {
    console.log(`[Storage Interceptor] setItem called: ${key}`);
    
    // Intercept auth_tokens and redirect to UnifiedStorage
    if (key === 'auth_tokens') {
      console.log('[Storage Interceptor] Redirecting auth_tokens to UnifiedStorage');
      try {
        const tokens = JSON.parse(value);
        unifiedStorage.setTokens(tokens);
        return;
      } catch (e) {
        console.error('[Storage Interceptor] Failed to parse auth_tokens:', e);
      }
    }
    
    // Intercept current_event_id
    if (key === 'current_event_id') {
      console.log('[Storage Interceptor] Redirecting current_event_id to UnifiedStorage');
      unifiedStorage.setEventId(value);
      return;
    }
    
    // For other keys, use original method
    return originalSetItem.call(this, key, value);
  };

  // Override getItem
  Storage.prototype.getItem = function(key: string) {
    console.log(`[Storage Interceptor] getItem called: ${key}`);
    
    // Intercept auth_tokens and get from UnifiedStorage
    if (key === 'auth_tokens') {
      console.log('[Storage Interceptor] Getting auth_tokens from UnifiedStorage');
      const tokens = unifiedStorage.getTokens();
      return tokens ? JSON.stringify(tokens) : null;
    }
    
    // Intercept current_event_id
    if (key === 'current_event_id') {
      console.log('[Storage Interceptor] Getting current_event_id from UnifiedStorage');
      return unifiedStorage.getEventId();
    }
    
    // For other keys, use original method
    return originalGetItem.call(this, key);
  };

  // Override removeItem
  Storage.prototype.removeItem = function(key: string) {
    console.log(`[Storage Interceptor] removeItem called: ${key}`);
    
    // Intercept auth_tokens
    if (key === 'auth_tokens') {
      console.log('[Storage Interceptor] Clearing tokens from UnifiedStorage');
      unifiedStorage.clearTokens();
      return;
    }
    
    // Intercept current_event_id
    if (key === 'current_event_id') {
      console.log('[Storage Interceptor] Clearing event ID from UnifiedStorage');
      unifiedStorage.clearEventId();
      return;
    }
    
    // For other keys, use original method
    return originalRemoveItem.call(this, key);
  };

  console.log('[AuthStorageAdapter] Interceptors installed successfully');
  
  // Removed automatic test that was overwriting real tokens
  // To test manually, use: localStorage.setItem('auth_tokens', JSON.stringify({ accessToken: 'your_token' }))
}

// Function to restore original localStorage methods (for debugging)
export function restoreOriginalStorage() {
  Storage.prototype.setItem = originalSetItem;
  Storage.prototype.getItem = originalGetItem;
  Storage.prototype.removeItem = originalRemoveItem;
  console.log('[AuthStorageAdapter] Original localStorage methods restored');
}